import { render, staticRenderFns } from "./AmountSection.vue?vue&type=template&id=d24df6d4&scoped=true&"
import script from "./AmountSection.vue?vue&type=script&lang=js&"
export * from "./AmountSection.vue?vue&type=script&lang=js&"
import style0 from "./AmountSection.vue?vue&type=style&index=0&id=d24df6d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24df6d4",
  null
  
)

export default component.exports